module.exports = __webpack_public_path__ + "static/media/promo.9afe51e8.png";